import { render, staticRenderFns } from "./SectionPanel.vue?vue&type=template&id=a5013a52&scoped=true"
import script from "./SectionPanel.vue?vue&type=script&lang=js"
export * from "./SectionPanel.vue?vue&type=script&lang=js"
import style0 from "./SectionPanel.vue?vue&type=style&index=0&id=a5013a52&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5013a52",
  null
  
)

export default component.exports